module.exports = __webpack_public_path__ + "img/ic_bwin.8e2ec5c1.svg";